/**
 * Largest party any published unit can host. BlueKeys capacity = bedrooms × 2,
 * and the biggest current inventory is a 6-bedroom villa (sleeps 12). The
 * catalogue-wide guest pickers (homepage hero, /search funnel + sheet, desktop
 * filter bar) cap at this so a visitor can't search for a headcount NO unit can
 * host (which silently returns "0 homes"). Per-unit BOOKING pickers ignore this
 * and use the exact `units.guests` capacity instead.
 *
 * Plain module (no "use client", no server deps) so it imports safely into both
 * client components and server components. Bump when a larger villa onboards.
 */
export const MAX_GUEST_CAPACITY = 12;
